module.exports = __webpack_public_path__ + "static/icons_startseite_kultur-a0a7c2481316bb8a1945e69c0d74c384.png";